import { z } from "zod";
/** Kenyan phone in `07XXXXXXXX`, `01XXXXXXXX` or `2547XXXXXXXX` format. */
export const kePhone = z
    .string()
    .regex(/^(?:\+?254|0)[17]\d{8}$/u, "Must be a valid Kenyan phone number");
export const isoDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/u, "Must be YYYY-MM-DD");
export const futureDateIso = isoDate.refine((d) => d >= new Date().toISOString().slice(0, 10), { message: "Cover start date must be today or a future date" });
export const identityBlock = z.object({
    icpakMemberNumber: z.string().min(1),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    phone: kePhone,
    email: z.string().email(),
    memberVerified: z.boolean().default(false),
});
export const quoteLineItem = z.object({
    code: z.string(),
    label: z.string(),
    amountKes: z.number(),
    note: z.string().optional(),
});
export const quote = z.object({
    product: z.string(),
    ratesVersion: z.string(),
    currency: z.literal("KES"),
    items: z.array(quoteLineItem),
    subtotalKes: z.number(),
    leviesKes: z.number(),
    stampDutyKes: z.number(),
    totalKes: z.number(),
});
